import { isObject } from "@/shared/utils/typeGuards";

export interface ApiErrorBody {
    ok: false;
    error: string;
}

export const isApiErrorBody = (response: unknown): response is ApiErrorBody =>
    isObject(response) && response.ok === false && typeof response.error === "string";

export interface DownloadUrlResponse {
    ok: true;
    downloadUrl: string;
}

export const isDownloadUrlResponse = (response: unknown): response is DownloadUrlResponse =>
    isObject(response) && response.ok === true && typeof response.downloadUrl === "string";

export interface ApiEndpoint<TBody, TSuccess> {
    route: string;
    label: string;
    source: string;
    category: string;
    description: string;
    /**
     * Served from a deployment that is not cleared for customer-facing use:
     * Modal's preprod or main environment, or a partner's evaluation API (Lyria). Apps
     * and capabilities that run it carry the R&D Only tag. See
     * docs/09-model-hosting.md.
     */
    isEvaluationOnly?: boolean;
    isRequestBody: (v: unknown) => v is TBody;
    isSuccessResponse: (v: unknown) => v is TSuccess;
}
